import { ID_ADMINISTRATION_STONE, TPAG_CARTAO_CREDIT, TPAG_CARTAO_DEBIT } from '../../../enums/PaymentMode';
import * as types from './mutation-types';

export const getUsedTEF = async (context, payload = {}) => {
  let used = true;
  if (!payload.stoneConfigurated) {
    used = false;
  }
  if (payload.isStoneInUseByZpos) {
    used = false;
  }
  const pagymentModeStone = payload.paymentModeCollection.filter((e) => {
    if (e.cardAdministrator &&
      e.cardAdministrator.id === ID_ADMINISTRATION_STONE &&
      [TPAG_CARTAO_DEBIT, TPAG_CARTAO_CREDIT].indexOf(e.paymentType.tPag) !== -1
    ) {
      return e;
    }
    return undefined;
  });
  if (pagymentModeStone.length !== 1) {
    used = false;
  }
  if (pagymentModeStone[0]) {
    if (pagymentModeStone[0].transactionNumber) {
      used = false;
    }
  }
  context.commit(types.SET_USED_TEF, used);
  return used;
};
